import React from 'react';
import { useHireBar, fmtScore, scoreTone } from './HireBarContext';

/**
 * Prototype scoreChip(). `result` is a normalised result
 * ({ state: 'done' | 'scoring' | 'inprogress' | 'invited', value, band, hireBar }) or null
 * for "not assigned". Pass/below uses the result's own batch hire bar (result.hireBar),
 * else the `hireBar` prop, else HireBarProvider.
 */
export default function ScoreChip({ result, hireBar: hireBarProp, style }) {
  const ctx = useHireBar();
  const hireBar = result?.hireBar ?? hireBarProp ?? ctx;
  if (!result) return <span className="wz-chip na" title="Not assigned" style={style}>—</span>;
  if (result.state === 'scoring') return <span className="wz-chip scoring" title="Completed, score pending" style={style}>Scoring</span>;
  if (result.state === 'inprogress') return <span className="wz-chip scoring" title="Started, not finished" style={style}>In progress</span>;
  if (result.state === 'invited') return <span className="wz-chip invited" title="Invited, not started" style={style}>Not started</span>;
  if (result.value == null && result.band) {
    return <span className="wz-chip band" title="CEFR band (language proficiency)" style={style}>{result.band}</span>;
  }
  // Language exams: the score plus its CEFR band, as in the report header.
  return (
    <span className={`wz-chip ${scoreTone(result.value, hireBar)}`} title={`Score out of 100${result.band ? ` · CEFR ${result.band}` : ''} · hire bar ${fmtScore(hireBar)}`} style={style}>
      {fmtScore(result.value)}{result.band ? ` · ${result.band}` : ''}
    </span>
  );
}

/** Prototype avgChip(): an average, or a grey "—" when nothing is scored. */
export function AvgChip({ value, hireBar: hireBarProp, style }) {
  const ctx = useHireBar();
  const hireBar = hireBarProp ?? ctx;
  if (value == null) return <span className="wz-chip none" style={style}>—</span>;
  return <span className={`wz-chip ${scoreTone(value, hireBar)}`} style={style}>{fmtScore(value)}</span>;
}
